<template>
    <div>
        <TextBanner>

            <font size=3><strong></strong></font><br>
            <p></p>
            Eine Story von: <b>Petra Pezelj</b><br>
            <p></p>
            3D-Grafik: <b>Christian Dupont</b><br>
            <p></p>
            Redaktion: <b>J. Werner, K. Kaminski</b><br>

  
        </TextBanner>
        
        <Fallback>
            <picture>
                <source media="(orientation: portrait)" srcset="../assets/img/fallback/13_Credits_iPad_P.jpg">
                <source media="(orientation: landscape)" srcset="../assets/img/fallback/13_Credits_iPad_L.jpg">
                <!-- The img element is required as the last child tag of the picture declaration block. The img element is used to provide backward compatibility for browsers that do not support the picture element, or if none of the source tags matched. -->
                <!--<img class="o-fit o-fit--cover" src="../assets/img/fallback/TextBanner.jpg" alt="">-->
                <img class="o-fit o-fit--cover" src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" alt="">
            </picture>
        </Fallback>
    </div>
</template>

<script>
    export default {
        name: 'credits',
        babylonState: {
            moveCamera: [-9.6,1.4,30,7,2,0],

            Geo_Tschernobyl:{
                children:{

                BG_Sphere: true,

                Geo_Sperrzone: true,


                Geo_Beton_Sarkophag_Rost: true,
                Geo_Schattenplane_Betonsarkophag: true,
                Geo_Schienen_Sarkophag: true,
                Geo_Textur1_Reaktor_4_Damage: false,
                Geo_Textur1_Reaktor_4_Damage_Aussen: false,
                Geo_Textur1_Reaktor_4_Damage_Innen: false,

                Geo_Neuer_Sarkophag_endpos: true,
                Geo_Schattenplane_NSC: true,

                Geo_KleinerTurm_Geruest1: true,
                Geo_KleinerTurm_RoteStreifen1: true,
                Geo_KleinerTurm_Schlot1: true,
                Geo_KleinerTurm_Schattenplane: true,
                
                Geo_GrosserTurm_Gestaenge1: false,
                Geo_GrosserTurm_Schlot1: false,
                Geo_GrosserTurm_RoteStreifen1: false,
                Geo_GrosserTurm_Schattenplane: false,


                }
            },

            fire: false,
        },
        
        babylonReady: function () {

            this.$audioController.initTrack('background', require('./../assets/audio/Geigerzaehler.mp3'), true, false),
            this.$babylonController.setAutoRotateBehaviour(true),
            this.$babylonController.setCameraRadiusLimit (3.5,30),
            this.$babylonController.zoomCamera(1.5)
        }
        
    }

    

</script>

<style lang="scss">

</style>